import AppButton from "../../components/common/AppButton";
import AppForm from "../../components/common/AppForm";
import AppLoader from "../../components/common/AppLoader";
import { useAsync } from "../../hooks";
import { LoginData, UserLogin } from "../../interface";
import { loginFields } from "../../constants";
import { auth } from "../../services";
import { authSchema } from "../../utils";
import { useUser } from "../../context/UserContext";
import { forgotPassword } from "../../services";
import "./style.css";

import { useNavigate } from "react-router-dom";
import { useState } from "react";

const Login = () => {
  const navigate = useNavigate();
  const { loading, execute, error } = useAsync<UserLogin, [LoginData]>();
  const { loading: forgotLoading, execute: executeForgotPassword } = useAsync<
    string,
    [string]
  >();
  const { setUser } = useUser();
  const [localError, setLocalError] = useState("");

  const isLoading = loading || forgotLoading;

  const handleSubmit = async (values: LoginData) => {
    try {
      const response = await execute(auth, values);
      if (response) {
        localStorage.setItem("token", response.token);
        setUser(response.user);
        navigate("/");
      }
    } catch (err: any) {
      setLocalError(err?.message || "Login failed");
    }
  };

  const handleForgotPassword = async () => {
    if (!document.querySelector<HTMLInputElement>("#email")?.value) {
      alert("Please enter your email first.");
      return;
    }

    const email = document.querySelector<HTMLInputElement>("#email")!.value;

    try {
      await executeForgotPassword(forgotPassword, email);
      alert("A password reset email has been sent to your email.");
    } catch (err) {
      console.error(err);
      alert("Failed to send reset email.");
    }
  };

  return (
    <div className="container-fluid vh-100">
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <AppLoader />
        </div>
      )}
      <div className="row h-100">
        {/* Left Panel */}
        <div className="col-md-6 d-flex align-items-center justify-content-center bg-white">
          <div className="w-100" style={{ maxWidth: 400 }}>
            <h2 style={{ color: "#38b2ac", fontWeight: 600 }}>Welcome Back</h2>
            <p style={{ color: "#a0aec0", fontSize: "0.9rem" }}>
              Enter your email and password to sign in
            </p>

            <AppForm
              initialValues={{ email: "", password: "" }}
              schema={authSchema}
              handleSubmit={handleSubmit}
              inputFields={loginFields}
              onInputChange={(field, value) => {
                if ((field === "email" || field === "password") && localError) {
                  setLocalError("");
                }
              }}
            >
              {({ isSubmitting }) => (
                <>
                  {localError && (
                    <div className="text-danger small mb-2" id="login-error">
                      {localError}
                    </div>
                  )}

                  <div className="mb-3 text-end">
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      onClick={handleForgotPassword}
                      style={{ fontSize: "12px" }}
                    >
                      Forgot Password?
                    </button>
                  </div>

                  <AppButton
                    label="SIGN IN"
                    size="md"
                    fullWidth
                    disabled={isSubmitting}
                  />
                </>
              )}
            </AppForm>
          </div>
        </div>

        {/* Right Panel */}
        <div
          className="col-md-6 d-none d-md-flex align-items-center justify-content-center text-white"
          style={{
            background:
              "linear-gradient(135deg,rgb(35, 110, 103) 0%, #4fd1c5 100%)",
          }}
        >
          <div className="text-center px-4">
            <h1 className="display-4 fw-bold">Price Comparison Tool</h1>
            <p className="lead">
              Start managing your dashboard effectively today.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
